export * from '../funcionario/list/funcionarioList.component';
export * from '../funcionario/create/funcionarioCreate.component';
export * from '../funcionario/edit/funcionarioEdit.component';
export * from '../funcionario/detail/funcionarioDetail.component';
export * from '../funcionario/search/funcionarioSearch.component';